export const GET_PARCEL_REQUESTS = 'GET_PARCEL_REQUESTS';
export const GET_PARCEL_REQUESTS_ERROR = 'GET_PARCEL_REQUESTS_ERROR';
export const UPDATE_PARCEL = 'UPDATE_PARCEL';
export const STATUS_PARCEL = 'STATUS_PARCEL';
export const STATUS_PARCEL_ERROR = 'STATUS_PARCEL_ERROR';
export const CREATE_PARCEL = 'CREATE_PARCEL';
export const CREATE_PARCEL_ERROR = 'CREATE_PARCEL_ERROR';
export const PARCEL_DASHBOARD = 'PARCEL_DASHBOARD';
export const PARCEL_DASHBOARD_ERROR = 'PARCEL_DASHBOARD_ERROR';